import type { PermissionCheck } from '@/lib/auth/permissions'
import type { WidgetSize, WidgetTone, WidgetType } from '../types'

export type WidgetMeta = {
  perm?: PermissionCheck
  /** Yalnız kullanıcının kendisine ait veri gösterir. */
  personal?: boolean
  /** Hassas veri; kütüphanede "Yetkili" rozetiyle işaretlenir. */
  restricted?: boolean
  to?: string
  w: WidgetSize
  h: WidgetSize
  tone: WidgetTone
  supportsView: boolean
  frameless?: boolean
}

export const WIDGET_META: Record<WidgetType, WidgetMeta> = {
  kpiOpenTasks: { perm: 'tasks.write', to: '/projects/boards', w: 1, h: 1, tone: 'primary', supportsView: false, frameless: true },
  kpiOverdueTasks: { perm: 'tasks.write', to: '/projects/boards', w: 1, h: 1, tone: 'danger', supportsView: false, frameless: true },
  kpiOverdueFollowups: { perm: 'crm:account:read', to: '/customers/followups', w: 1, h: 1, tone: 'orange', supportsView: false, frameless: true },
  kpiActiveDemos: { perm: 'accounts.read', to: '/customers/delivery', w: 1, h: 1, tone: 'success', supportsView: false, frameless: true },
  myTasks: { perm: 'tasks.write', to: '/projects/boards', w: 2, h: 3, tone: 'primary', supportsView: true },
  payments: { perm: ['crm:finance:read', 'finance:ledger:read', 'finance:planned:manage'], to: '/customers/collections', w: 2, h: 3, tone: 'orange', supportsView: true },
  notes: { personal: true, w: 2, h: 3, tone: 'violet', supportsView: true },
  calendar: { to: '/customers/meetings', w: 2, h: 3, tone: 'danger', supportsView: false },
  projects: { perm: 'projects:read', to: '/projects/boards', w: 4, h: 3, tone: 'success', supportsView: true },
  meetings: { perm: 'crm:meeting:read', to: '/customers/meetings', w: 2, h: 3, tone: 'success', supportsView: true },
  followups: { perm: 'crm:account:read', to: '/customers/followups', w: 2, h: 3, tone: 'primary', supportsView: true },
  endingDemos: { perm: 'accounts.read', to: '/customers/delivery', w: 2, h: 3, tone: 'orange', supportsView: true },
  installHealth: { perm: 'accounts.read', restricted: true, to: '/installations', w: 2, h: 2, tone: 'neutral', supportsView: false },
  financeSummary: { perm: 'finance:ledger:read', restricted: true, to: '/finance', w: 2, h: 3, tone: 'neutral', supportsView: false },
}
